import { BaseModel } from '../base.model';

export class NiftySubLocationInventory extends BaseModel {
  subLocationId: number;
  subLocationName: string;
  subLocationInvId: number;
  onHand: number;
  inProcess: number;
}
